import { LANDING_AMPLITUDE_EVENTS, LOCAL_STORAGE_KEYS } from '@/constants';
import benefit from '@/public/images/pixverse-ai-video-generator/benefits.webp';
import howWork from '@/public/images/pixverse-ai-video-generator/howItWorks.webp';
import whyLift from '@/public/images/pixverse-ai-video-generator/whyLift.webp';
import { type LandingConfigItem } from '../../types';
import { tryLiftConfig } from './tryLiftConfig';

export const landingPixverseAiVideoGeneratorConfig: LandingConfigItem = {
	id: 'pixverse-ai-video-generator',
	translationLocale: 'pixverse-ai-video-generator',
	withDropZone: false,
	hero: {
		type: 'textToVideo',
		title: 'heroData_title',
		description: 'heroData_subtitle',
		data: {
			inputPlaceholder: 'heroData_inputPlaceholder',
			modelName: 'PixVerse',
		},
		buttonText: 'heroData_buttonText',
	},
	howItWork: {
		title: 'howItWorkData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '✍️',
				title: 'howItWorkData_title1',
				subtitle: 'howItWorkData_subtitle1',
			},
			{
				icon: '🎬',
				title: 'howItWorkData_title2',
				subtitle: 'howItWorkData_subtitle2',
			},
			{
				icon: '✨',
				title: 'howItWorkData_title3',
				subtitle: 'howItWorkData_subtitle3',
			},
			{
				icon: '🤘',
				title: 'howItWorkData_title4',
				subtitle: 'howItWorkData_subtitle4',
			},
		],
		images: [
			{
				image: howWork,
				title: 'howItWorkData_imageTitle',
				alt: 'howItWorkData_imageAlt',
			},
		],
	},
	benefits: {
		title: 'benefitData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '🔹',
				subtitle: 'benefitData_subtitle1',
			},
			{
				icon: '🔹',
				title: '',
				subtitle: 'benefitData_subtitle2',
			},
			{
				icon: '🔹',
				subtitle: 'benefitData_subtitle3',
			},
			{
				icon: '🔹',
				subtitle: 'benefitData_subtitle4',
			},
			{
				icon: '🔹',
				subtitle: 'benefitData_subtitle5',
			},
		],
		images: [
			{
				image: benefit,
				title: 'benefitData_imageTitle',
				alt: 'benefitData_imageAlt',
			},
		],
	},
	faq: {
		title: 'faqData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				title: 'faqData_title1',
				subtitle: 'faqData_subtitle1',
			},
			{
				title: 'faqData_title2',
				subtitle: 'faqData_subtitle2',
			},
			{
				title: 'faqData_title3',
				subtitle: 'faqData_subtitle3',
			},
			{
				title: 'faqData_title4',
				subtitle: 'faqData_subtitle4',
			},
			{
				title: 'faqData_title5',
				subtitle: 'faqData_subtitle5',
			},
		],
	},
	whyLift: {
		title: 'whyUseData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '✅',
				title: 'whyUseData_title1',
				subtitle: 'whyUseData_subtitle1',
			},
			{
				icon: '✅',
				title: 'whyUseData_title2',
				subtitle: 'whyUseData_subtitle2',
			},
			{
				icon: '✅',
				title: 'whyUseData_title3',
				subtitle: 'whyUseData_subtitle3',
			},
			{
				icon: '✅',
				title: 'whyUseData_title4',
				subtitle: 'whyUseData_subtitle4',
			},
		],
		images: [
			{
				image: whyLift,
				title: 'whyUseData_imageTitle',
				alt: 'whyUseData_imageAlt',
			},
		],
	},
	tryLift: {
		...tryLiftConfig,
	},
	analytics: {
		scrolledPercentName:
			LOCAL_STORAGE_KEYS.PIXVERSE_AI_VIDEO_GENERATOR_SCROLLED_POINTS,
		eventPropertyType: LANDING_AMPLITUDE_EVENTS.PIXVERSE_AI_VIDEO_GENERATOR,
		galleryContext:
			LANDING_AMPLITUDE_EVENTS.PIXVERSE_AI_VIDEO_GENERATOR_LANDING,
	},
};
